<div [formGroup]="formGroup" [ngStyle]="border">
  @for (elt of ar; track elt.id; let j = $index) {
    <div class='left-header-cell price-header-cell' [ngStyle]="elt.style">
      @switch (elt.id) {
        @case ('HEADER') {
          <span>{{ elt.header }}<br>{{ elt.header2 }}</span>
        }
        @default {
          <span>
            @if (elt.isElligible | CheckEligiblePipe) {
              <span><span style="font-size: 28px">{{ elt.header }} {{ elt.extension }}</span>{{ elt.header2 }}</span>
            } @else {
              <span><img [src]="elt.img" style="width: 126px;"></span>
            }
          </span>
        }
      }
    </div>
  }

  <ng-container *ngrxLet="(changePrice$ | ngrxPush) as prices">
    @if (!!prices) {
      <div class="left-header-cell price-header-cell" style="background-color: #EEEEEE;font-weight: 800;font-size: 17px">
        {{ prices | PricePrecoPipe : formuleSelected }} &nbsp;<span style="font-size: 10px">/mois<sup>(3)</sup></span>
        &nbsp;&nbsp;<mat-checkbox (change)="check($event['checked'], formuleSelected)"
                                  [formControlName]="formuleSelected"></mat-checkbox>
      </div>
    }
  </ng-container>
</div>
